import { APP_INIT_RECEIVE, APP_INIT_REQUEST, APP_URL_INIT } from 'moduleBase/constants';
import { of } from 'rxjs/internal/observable/of';
import { from } from 'rxjs/internal/observable/from';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { catchError } from 'rxjs/internal/operators/catchError';
import { ThunkAction } from 'components/redux/types/ThunkAction';
import { InitResponse } from 'moduleBase/actions/types/InitResponseType';
import { getLangFromPathname, setLangToPathname } from 'srcJs/helpers/LanguageHelper';
import { featureToggle } from '@collaborator/npm_modules/dist/components/featureToggle';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';

export const appInit = (): ThunkAction => (
  dispatch,
  getState,
  { networkService, history, app },
) => {
  dispatch({
    type: APP_INIT_REQUEST,
  });

  app.setLang(getLangFromPathname(history.location.pathname));
  networkService.setLang(app.getLang());
  const translate = app.getTranslate();

  const initObservable = from(networkService.get<InitResponse>(APP_URL_INIT));
  const translateObservable = from(translate.load()).pipe(
    catchError((error) => of(error)),
  );

  return new Promise<InitResponse>((resolve) => {
    forkJoin([initObservable, translateObservable])
      .subscribe((result) => {
        const initResult = result[0];
        app.getUser().setData(initResult.data.user);
        app.setLang(initResult.data.languageSettings.current);
        app.getExternalApp().setList(initResult.data.externalApps);
        featureToggle.addFeatures(initResult.data.features);
        featureToggle.parseCookie();
        if (!realtimeNotification.isConnected()) {
          realtimeNotification.reconnect({ userId: initResult.data.user.id });
        }

        const pathname = setLangToPathname(window.location.pathname, app.getLang());
        if (history.location.pathname !== pathname) {
          history.replace(pathname);
          dispatch(appInit());
          return;
        }

        dispatch({
          type: APP_INIT_RECEIVE,
          payload: {
            isInit: true,
            ...initResult.data,
          },
        });

        resolve(initResult.data);
      }, (error) => Promise.reject(error));
  });
};
